/**
 * メタデータ解説ページで利用する配布リンク定義
 *
 * 固定リンクとして運用し、表示文言は i18n 側で管理する。
 */

export type MetadataDistributionId =
  'graph' | 'works' | 'events' | 'vocabJsonLd';

export interface MetadataDistributionLink {
  id: MetadataDistributionId;
  path: string;
  format: 'application/ld+json';
  samplePath?: string;
}

export const METADATA_BASE_URL = 'https://takun-archive.org';
export const METADATA_LAST_UPDATED = '2026-02-25';

export const METADATA_DISTRIBUTION_LINKS: readonly MetadataDistributionLink[] =
  [
    {
      id: 'graph',
      path: '/data/json/graph.jsonld',
      format: 'application/ld+json',
    },
    {
      id: 'works',
      path: '/works/{id}.jsonld',
      samplePath: '/works/000001.jsonld',
      format: 'application/ld+json',
    },
    {
      id: 'events',
      path: '/events/{id}.jsonld',
      samplePath: '/events/100002.jsonld',
      format: 'application/ld+json',
    },
    {
      id: 'vocabJsonLd',
      path: '/data/json/vocab/vocab.jsonld',
      format: 'application/ld+json',
    },
  ] as const;

/**
 * 公開URLへ変換
 */
export function toMetadataPublicUrl(path: string): string {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${METADATA_BASE_URL}${normalizedPath}`;
}
